import { Theme, css } from '@emotion/react';

export const tockTenCardContainer = ({ spacing }: Theme) => css`
  padding: ${spacing(2)}px 0;
`;

export const tockTenCardContentContainer = ({ colors, spacing }: Theme) => css`
  background: ${colors.bgLighter};
  border-radius: ${spacing(1)}px;
  display: flex;
  padding: ${spacing(2)}px;
`;

export const tockTenCardImageContainer = () => css`
  flex-basis: 100px;
`;

export const tockTenCardImage = ({ spacing }: Theme) => css`
  border-radius: ${spacing(1)}px;
  width: 100px;
  height: 125px;
`;

export const tockTenCardTextContainer = ({ spacing }: Theme) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${spacing(2)}px;

  > p:nth-child(2) {
    margin-bottom: ${spacing(1)}px;
  }

  > a > svg {
    position: relative;
    top: 2px;
  }
`;
